import { useEffect, useRef } from "react"
import io from "socket.io-client"
import { useStore } from "../../components/Orbit/orbitStore"

const OrbitBroadcaster = () => {
  const socket = useRef()
  const url = process.env.REACT_APP_MARKETING_SUITE
  const role = process.env.REACT_APP_ROLE

  const showOverview = useStore(state => state.showOverview)
  const setShow = useStore(state => state.setShow)

  const index = useStore(state => state.index)
  const setIndex = useStore(state => state.setIndex)

  const direction = useStore(state => state.direction)
  const setDirection = useStore(state => state.setDirection)

  const ready = useStore(state => state.direction)
  const setReady = useStore(state => state.setDirection)

  const playing = useStore(state => state.playing)
  const setPlaying = useStore(state => state.setPlaying)

  const state = {
    index: index,
    direction: direction,
    playing: playing,
    showOverview: showOverview,
    ready: ready
  }

  useEffect(() => {
    socket.current = io(url)
    socket.current.emit("subscribe-orbitbroadcaster", 1000)
    if (role === "recipient") {
      socket.current.on("orbitbroadcaster", actAptZustand => {
        console.log("send")
        setIndex(actAptZustand.index)
        setDirection(actAptZustand.direction)
        setPlaying(actAptZustand.playing)
        setShow(actAptZustand.showOverview)
        setReady(actAptZustand.ready)
      })
    }
    return () => socket.current.close()
  }, [state, role, url])

  useEffect(() => {
    if (role === "sender") {
      socket.current.emit("orbitbroadcaster", state)
    }
  }, [state, role, url])

  return null
}

OrbitBroadcaster.propTypes = {}

export default OrbitBroadcaster
